import React from 'react';
import { Flex, Box, Text, Link } from '@backstage/ui';
import styles from './about.module.css';

export const MetadataItem = ({
  icon,
  label,
  value,
  href,
}: {
  icon: React.ReactNode;
  label: string;
  value: string | undefined;
  href?: string;
}) => {
  const displayValue = value || '-';

  return (
    <Flex direction="column" gap="1">
      <Flex gap="2" align="center">
        <Box className={styles.metaIconWrap}>
          {icon}
        </Box>
        <Text
          variant="body-x-small"
          color="secondary"
          className={styles.metaLabel}
        >
          {label}
        </Text>
      </Flex>
      <Box className={styles.metaValueWrap}>
        {href ? (
          <Link href={href} variant="body-medium">
            {displayValue}
          </Link>
        ) : (
          <Text variant="body-medium" color={value ? 'primary' : 'secondary'}>
            {displayValue}
          </Text>
        )}
      </Box>
    </Flex>
  );
};
